module.exports = __webpack_public_path__ + "static/texture-77c040841b3172ef38a535ac2ef3a9d7.jpg";